/**
 * What the signed-in user may do. The API sends the resolved list on
 * `/business/me`, so the portal never derives access from a role's name — and
 * hiding a screen is only ever a convenience: every action is checked again on
 * the server.
 */

/** True when the user carries the permission (the owner carries all of them). */
export const can = (user, permission) => {
  if (!user) return false;
  if (user.is_owner) return true;

  return (user.permissions ?? []).includes(permission);
};

/** True when the user carries at least one of the permissions. */
export const canAny = (user, permissions = []) =>
  permissions.length === 0 || permissions.some((permission) => can(user, permission));
